@if (showSocials()) {
  <div class="pb-2" [class]="position() == 'header' ? 'd-flex align-items-center gap-3' : ''">
    @if (position() == 'header') {
      <span>{{ 'SOCIAL.FOLLOW_US_ON' | translate }}</span>
    } @else {
      <h4>{{ 'SOCIAL.FOLLOW_US_ON' | translate }}</h4>
    }
    <ul class="list-inline text-left social">
      @for (social of socials; track social.name) {
        <li class="list-inline-item">
          <a class="text-white" [href]="social.url" target="_blank">
            <it-icon [name]="social.icon | translate" color="white" size="sm" class="mx-0" />
            <span class="visually-hidden">{{ social.name | translate }}</span>
          </a>
        </li>
      }
    </ul>
  </div>
}
